<div center-layout [fullHeight]="true">
  <div stack-layout [maxWidth]="720" [fullWidth]="true" gap="lg" padding="md">
    <Text
      display="block"
      align="center"
      role="headline-large"
      color="on-background-variant"
      >Welcome to Assurant Trade Bridge</Text
    >
    <Text display="block" align="center" role="headline-medium"
      >Select your region</Text
    >
    <div
      grid-layout
      gap="md"
      templateColumns="repeat(auto-fit, minmax(160px, 1fr))"
      [fullWidth]="true"
      [fullHeight]="true"
    >
      @for (region of regions.regions(); track region.id) {
        <div
          center-layout
          border="light"
          borderRadius="sm"
          elevation="raised"
          padding="md"
          tabindex="0"
          (click)="selectRegion(region)"
          (keydown.enter)="selectRegion(region)"
          (keydown.space)="selectRegion(region)"
          [class]="regionButton"
        >
          <Text role="title-small" align="center">{{ region.label }}</Text>
        </div>
      }
    </div>
  </div>
</div>
